export const shopTranslations = {
  ru: {
    title: "Магазин сервера",
    subtitle: "Поддержите проект и получите уникальные возможности на сервере.",
    cats: {
      all: "Все товары",
      premium: "RP Premium",
      services: "Услуги",
      crates: "Кейсы"
    },
    premium: {
      tag: "Подписка",
      title: "RP PREMIUM",
      desc: "Благословение Красных Фонарей. Получите максимум от игры с эксклюзивными функциями и уважением на сервере.",
      features: [
        "Косметика: свечение (/eglow), смена скинов мячей, полет в лобби.",
        "Кастомизация: уникальные сообщения входа/выхода/смерти, любой префикс/суффикс.",
        "Геймплей: отключение фантомов, прорисовка 10 чанков, размер игрока (/sizeplayer).",
        "Привилегии: вход на полный сервер, скрытие на dynmap, командный блок.",
        "Discord: спонсорский чат, голосовой канал (18+), уникальная роль."
      ],
      perMonth: "/ мес",
      btnManage: "Управление",
      btnGift: "В подарок",
      btnSubscribe: "Оформить подписку",
      agreementPart1: "Оформляя подписку, вы соглашаетесь на ",
      agreementTerms: "условия использования",
      agreementPart2: " и ",
      agreementPrivacy: "политику конфиденциальности",
      agreementPart3: "."
    },
    services: {
      title: "Услуги и предметы",
      pass: { 
        title: "Проходка", 
        desc: "Постоянный доступ к игре на сервере.", 
        fullDesc: "Дает постоянный доступ к серверу. Без проходки игра на сервере невозможна. Оплата разовая, доступ к аккаунту остается навсегда." 
      },
      unban: { 
        title: "Разбан", 
        desc: "Снятие блокировки игрокового аккаунта.", 
        fullDesc: "Снимает блокировку с вашего игрового аккаунта и очищает историю наказаний.\n\nВнимание: при повторном нарушении правил сервера блокировка может быть выдана снова." 
      },
      suffix: { 
        title: "Уникальный суффикс", 
        desc: "Кастомный суффикс в чате навсегда.", 
        fullDesc: "Позволяет установить кастомный текст (суффикс), который будет отображаться после вашего ника в чате.\n\nВыделитесь среди других игроков и сделайте свой профиль уникальным." 
      },
      twink: { 
        title: "Разрешение на твинк", 
        desc: "Легальное создание второго аккаунта.", 
        fullDesc: "Официальное разрешение на создание и использование второго аккаунта (твинка) на сервере без риска получить блокировку за мультиаккаунт." 
      }
    },
    crates: {
      title: "Кейсы лобби",
      epic: { 
        title: "Epic Crate", 
        fullDesc: "Содержит редкие косметические предметы, эффекты и уникальные частицы для использования в лобби.\n\nОткрывается на спавне (в лобби) в специальном сундуке." 
      },
      xmas: { 
        title: "Merry Christmas Crate", 
        badge: "Лимитка", 
        fullDesc: "Лимитированный сундук, доступный только во время новогодних праздников.\n\nСодержит эксклюзивные зимние эффекты, питомцев и уникальные скины, которые нельзя получить в другое время года." 
      }
    },
    actions: {
      giftHover: "Подарить",
      giftBtn: "В подарок",
      buyBtn: "Купить",
      gotIt: "Понятно"
    },
    modals: {
      notBannedTitle: "Вы не заблокированы",
      notBannedMsg: "Разбан можно купить только в подарок, так как ваш аккаунт не находится в бане.",
      suffixOwnedTitle: "Уже приобретено",
      suffixOwnedMsg: "У вас уже есть уникальный суффикс. Вы можете приобрести его только в подарок.",
      passGiftTitle: "Проходка (В подарок)",
      passGiftSub: "Доступ навсегда",
      premiumGiftTitle: "RP Premium (В подарок)",
      premiumGiftSub: "Подарочная подписка RP Premium (1 месяц)",
      premiumSubTitle: "RP Premium (Подписка)",
      premiumSubSub: "Оформление автопродления"
    }
  },
  en: {
    title: "Server Store",
    subtitle: "Support the project and unlock unique features on the server.",
    cats: {
      all: "All Items",
      premium: "RP Premium",
      services: "Services",
      crates: "Crates"
    },
    premium: {
      tag: "Subscription",
      title: "RP PREMIUM",
      desc: "Blessing of the Red Lanterns. Get the most out of the game with exclusive features and respect on the server.",
      features: [
        "Cosmetics: glow (/eglow), ball skins change, lobby flight.",
        "Customization: unique login/logout/death messages, any prefix/suffix.",
        "Gameplay: disable phantoms, 10 chunks render distance, player size (/sizeplayer).",
        "Privileges: full server access, dynmap hide, command block.",
        "Discord: sponsor chat, voice channel (18+), unique role."
      ],
      perMonth: "/ mo",
      btnManage: "Manage",
      btnGift: "Gift",
      btnSubscribe: "Subscribe",
      agreementPart1: "By subscribing, you agree to the ",
      agreementTerms: "Terms of Service",
      agreementPart2: " and ",
      agreementPrivacy: "Privacy Policy",
      agreementPart3: "."
    },
    services: {
      title: "Services & Items",
      pass: { 
        title: "Server Pass", 
        desc: "Permanent access to play on the server.", 
        fullDesc: "Grants permanent access to the server. Playing on the server is impossible without a pass. One-time payment, account access remains forever." 
      },
      unban: { 
        title: "Unban", 
        desc: "Remove the ban from your game account.", 
        fullDesc: "Removes the ban from your game account and clears the punishment history.\n\nWarning: in case of repeated violation of the server rules, the ban may be issued again." 
      },
      suffix: { 
        title: "Custom Suffix", 
        desc: "Permanent custom chat suffix.", 
        fullDesc: "Allows you to set custom text (suffix) that will be displayed after your nickname in the chat.\n\nStand out among other players and make your profile unique." 
      },
      twink: { 
        title: "Twink Permission", 
        desc: "Legal creation of a second account.", 
        fullDesc: "Official permission to create and use a second account (twink) on the server without the risk of getting banned for multi-accounting." 
      }
    },
    crates: {
      title: "Lobby Crates",
      epic: { 
        title: "Epic Crate", 
        fullDesc: "Contains rare cosmetic items, effects, and unique particles for use in the lobby.\n\nOpens at spawn (in the lobby) in a special chest." 
      },
      xmas: { 
        title: "Merry Christmas Crate", 
        badge: "Limited", 
        fullDesc: "Limited chest available only during the New Year holidays.\n\nContains exclusive winter effects, pets, and unique skins that cannot be obtained at any other time of the year." 
      }
    },
    actions: {
      giftHover: "Gift",
      giftBtn: "Gift",
      buyBtn: "Buy",
      gotIt: "Got it"
    },
    modals: {
      notBannedTitle: "You are not banned",
      notBannedMsg: "Unban can only be purchased as a gift because your account is not currently banned.",
      suffixOwnedTitle: "Already Owned",
      suffixOwnedMsg: "You already have a custom suffix. You can only purchase it as a gift.",
      passGiftTitle: "Server Pass (Gift)",
      passGiftSub: "Permanent access",
      premiumGiftTitle: "RP Premium (Gift)",
      premiumGiftSub: "Gift RP Premium subscription (1 month)",
      premiumSubTitle: "RP Premium (Subscription)",
      premiumSubSub: "Set up auto-renewal"
    }
  }
};